import React from 'react';
import ReactDOM from 'react-dom';
import { App } from './app';
import './index.less';
import { initI18n, initAegis } from '@common';
import resource from './locales/resource.json';

initAegis('QV7ZYsJXbow6Ka15ja');
initI18n({
  resource,
});

setTimeout(() => {
  ReactDOM.render(<App />, document.querySelector('#root'));
}, 0);
